import { createSlice } from '@reduxjs/toolkit';

const LICENSE_STORAGE_KEY = 'simms_x_license';

function readStoredLicense() {
    try {
        return sessionStorage.getItem(LICENSE_STORAGE_KEY) ?? undefined;
    } catch {
        return undefined;
    }
}

const initialState = {
    isLoggedIn: false,
    user: undefined,
    license: readStoredLicense(),
    platFrom:'IAM'
};

const authSlice = createSlice({
    name: 'auth',
    initialState,
    reducers: {
        login(state, action) {
            state.isLoggedIn = true;
            state.user = action.payload;
        },
        logout(state) {
            localStorage.removeItem("accessToken");
            sessionStorage.removeItem(LICENSE_STORAGE_KEY);
            state.isLoggedIn = false;
            state.user = null;
            state.license = undefined;
        },
        setLicense(state, action){
            state.license = action.payload;
            if (action.payload != null && action.payload !== '') {
                sessionStorage.setItem(LICENSE_STORAGE_KEY, action.payload);
            }
        },
        setPlatFrom(state, action){
            state.platFrom =action.payload
        }
    },
});

export const { login, logout, setLicense, setPlatFrom} = authSlice.actions;

export default authSlice.reducer;
